/* eslint-disable no-unused-vars */
import React, {PureComponent} from 'react';
import {fromJS} from 'immutable';
import {  Container, Table, Rating, Header, Icon, Pagination, Statistic, Grid, Button, Loader, Feed, Popup, List, Card, Segment, Sidebar, Menu, Label } from 'semantic-ui-react'
import _ from 'lodash';
import moment from 'moment';

import { MARGIN_LEFT } from './Map';
import SessionsList from './sessions-list';

import UsersList from './users-list';

export default class SideBar extends PureComponent {

  state = {
    activeItem: 'visible-sessions',
    visible: true
  }

  handleItemClick = (e, { name }) => {
    // const activeItem = this.state.activeItem == name ? null : name;
    if(this.state.visible)
      this.setState({ name, visible: false });
    else
      this.setState({ activeItem: name, visible: true });
  }

  _onHidden = () => {
    console.log('check to see if we should show again');
    const activeItem = this.state.activeItem === this.state.name ? null :  this.state.name;
    this.setState({
      activeItem: activeItem,
      visible: activeItem === null ? false : true,
    });
  }

  render() {
    const { activeItem, visible } = this.state
    const { features, activeFeatureId, activeSidebar} = this.props;


    const orderedSessions = _.orderBy(features,['properties.timestamp'],['desc'])

    return (
      <div>
         <Sidebar
           inverted={false}
           as={Menu}
           style={{left: MARGIN_LEFT + 30}}
           direction='left'
           visible={visible}
           onHidden={this._onHidden}
           vertical

           animation='overlay'
         >


         {activeItem === 'recent-sessions' && <SessionsList {...this.props} activeItem={activeItem} />}
         {activeItem === 'visible-sessions' && <SessionsList {...this.props} activeItem={activeItem} />}
         {activeItem === 'best-sessions' && <SessionsList {...this.props} activeItem={activeItem} />}
         {activeItem === 'users' && <UsersList {...this.props} />}


           </Sidebar>

           <Sidebar
            as={Menu}
              direction='left'
              inverted={true}
              icon={true}
              vertical
              visible={true}
              width='very thin'
              >
                <Menu.Item as='a'  name='recent-sessions' active={activeItem === 'recent-sessions'} onClick={this.handleItemClick} ><Icon name='clock' color={activeItem === 'recent-sessions' ? 'yellow' : 'grey'} /></Menu.Item>
                <Menu.Item as='a' name='visible-sessions' active={activeItem === 'visible-sessions'} onClick={this.handleItemClick}><Icon name='map' color={activeItem === 'visible-sessions' ? 'yellow' : 'grey'}/></Menu.Item>
                <Menu.Item as='a' name='best-sessions' active={activeItem === 'best-sessions'} onClick={this.handleItemClick}><Icon name='eye' color={activeItem === 'best-sessions' ? 'yellow' : 'grey'}/></Menu.Item>
                <Menu.Item as='a' name='users' active={activeItem === 'users'} onClick={this.handleItemClick}><Icon name='users' color={activeItem === 'users' ? 'yellow' : 'grey'}/></Menu.Item>


              </Sidebar>

         </div>
    )



  }
}



// WEBPACK FOOTER //
// ./src/components/pages/Dashboard/v3/side-bar.js